import { post } from "@/util/http";
const COS = require("cos-js-sdk-v5");

export default {
  methods: {
    upload(file) {
      console.log(Date.parse(new Date()), this.getFileNameFormat(file.name), "this.getFileNameFormat(file.name)");
      return new Promise((resolve, reject) => {
        post({ url: "/api/qcloud_sts" }).then((result) => {
          if (result.status === 200) {
            const res = result.data;
            if (res.status === 0) {
              // 初始化实例
              const cos = new COS({
                getAuthorization: function (options, callback) {
                  const credentials = res.data.Credentials;
                  callback({
                    TmpSecretId: credentials.TmpSecretId,
                    TmpSecretKey: credentials.TmpSecretKey,
                    XCosSecurityToken: credentials.Token,
                    ExpiredTime: res.data.ExpiredTime,
                  });
                },
              });

              cos.putObject(
                {
                  Bucket: res.data.bucket,
                  Region: res.data.region,
                  Key: "images/" + res.data.filename + this.getFileNameFormat(file.name),
                  Body: file,
                },
                function (err, data) {
                  if (err) {
                    resolve({ status: 1, msg: "上传失败" });
                  } else {
                    if (data.statusCode === 200) {
                      resolve({ status: 0, msg: "上传成功", data: "https://" + data.Location });
                    } else {
                      reject({ status: 1, msg: "上传失败" });
                    }
                  }
                }
              );
            }
          } else {
            resolve({ status: 1, msg: "上传失败" });
          }
        });
      });
    },
    getFileNameFormat(filename) {
      const myArray = filename.split(".");
      let formatName = "." + myArray.pop();
      return formatName;
    },
  },
};
